'use client';

import { useSyncExternalStore } from 'react';

/**
 * Pinch destination toggle — a module store on the discover-events pattern:
 * the mobile bar's zoom menu renders the toggle, the canvas's forwarded-pinch
 * terminator reads it, no prop threading.
 *
 * OFF (default): a two-finger gesture anywhere is workspace navigation —
 * gestures starting inside an app are measured there and forwarded out.
 * ON: forwarded pinches are ignored by the canvas, so an app with its own
 * pinch handling (drawing canvases, maps, documents) gets the gesture to
 * itself. The apps always RECEIVE the touches either way (preventDefault
 * never blocks delivery); this only decides whether the workspace camera
 * acts on them too. Canvas-started gestures stay navigation regardless —
 * fingers on the workspace mean the workspace.
 */

let on = false;
const subs = new Set<() => void>();

export function toggleAppPinch(): void {
  on = !on;
  subs.forEach((fn) => fn());
}

export function isAppPinchOn(): boolean {
  return on;
}

const getSnapshot = () => on;
const getServerSnapshot = () => false;

export function useAppPinch(): boolean {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    getSnapshot,
    getServerSnapshot,
  );
}
